/**
 * env.ts — the lander's build-time configuration (ENG-417).
 *
 * Every value is a Vite build-time constant injected by the deploying stack
 * (infra/lib/edge-stack.ts inviteLanderSource for dev/staging, the shared-services
 * apex stack for prod). Hard-required at module load: a deployable bundle built
 * without one throws before anything renders, and the build itself fails first
 * under SUVI_INVITE_LANDER_REQUIRE_VITE_ENV=1 (see vite.config.ts, ENG-352's
 * pattern). The platform API is reached SAME-ORIGIN through the lander
 * distribution's /v1/invitations/* proxy behavior, so no API base is configured
 * here and no CORS surface exists. The page never authenticates (spec 5.3/5.4):
 * it carries no Descope configuration at all — sign-in happens only in-app, via
 * native Apple/Google OAuth, after install.
 */

export const env = {
  /** Production-only store destinations. Empty in dev and staging artifacts. */
  iosAppStoreUrl: (import.meta.env.VITE_IOS_APP_STORE_URL ?? "").trim(),
  androidPlayStoreUrl: (import.meta.env.VITE_ANDROID_PLAY_STORE_URL ?? "").trim(),
  /**
   * Explicitly false in every current environment. Activation requires enrolled
   * Play-account listing and physical-device install proof for that variant.
   */
  androidInstallBannerEnabled:
    import.meta.env.VITE_ANDROID_INSTALL_BANNER_ENABLED?.trim() === "true",
} as const;
